import React, { useState, useEffect } from "react";
import Convinced from "./Convinced";
import OrderFulfilment from "./OrderFulfilment";
import ProductionImprovement from "./ProductionImprovement";
import QualityControll from "./QualityControll";
import StaffManagement from "./StaffManagement";
import WarehouseManagement from "./WarehouseManagement";
import WorkspaceInst from "./WorkspaceInst";
import tourImg from "../../../assets/tour.png"


const ShowStep = (Step) => {
  switch (Step) {
    case 0:
      return (
        <>
        <ProductionImprovement />
         
        </>
      );
    case 1:
      return (
        <>
          <WorkspaceInst />
        </>
      );
    case 2:
      return (
        <>
          <QualityControll />
        </>
      );
    case 3:
      return (
        <>
          <WarehouseManagement />
        </>
      );
    case 4:
      return (
        <>
          <StaffManagement />
        </>
      );
    case 5:
      return (
        <>
          <OrderFulfilment />
        </>
      );
    case 6:
      return (
        <>
          <Convinced />
        </>
      );
  }
};
function Tour() {
  const [step, setstep] = useState(0);
  const handleNext = () => {
    // if (step <= 5) {
    //   setstep(step + 1);
    // } else {
    //   setstep(0);
    // }
  };
  useEffect(() => {
    setTimeout(() => {
      if (step <= 5) {
        setstep(step + 1);
      } else {
        setstep(0);
      }
    }, 5000);
  }, [step]);
  console.log("step", step);
  return (
    <>

    <div className="animate__animated animate__zoomIn ">
      <div className="container  w-4/5  mx-auto  px-4 my-28">
        <div className="grid grid-cols-2 gap-20 font-Montserrat">
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <h2 className="text-black text-4xl font-bold">
              The Tour
            </h2>
            <p className="font-medium">
            Tour will contain a step-by-step system, it will show how the steps are working how our production helps staff members create products/follow instructions
            </p>
            
          </div>
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <div>
              <img
                src={tourImg}
                alt="Logo"
                className="h-80 rounded-sm  "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <div className="">
      {ShowStep(step)}
      </div> */}
      <ProductionImprovement />
      <WorkspaceInst />
      <QualityControll />
      <WarehouseManagement />
      <StaffManagement />
      <Convinced />
      
    </>
  );
}

export default Tour;
